import { AudioTranscriptionConfigMode, Modality, type LiveConnectConfig } from "@google/genai";

export const GEMINI_TRANSCRIPTION_MODEL = "gemini-3.5-transcribe-live";

// Keep this byte-for-byte equivalent on the ephemeral token and browser Live
// connection: Gemini rejects a session that exceeds its token constraints.
export const GEMINI_TRANSCRIPTION_CONFIG = {
  responseModalities: [Modality.TEXT],
  realtimeInputConfig: {
    automaticActivityDetection: { disabled: true },
  },
  inputAudioTranscription: {
    languageCodes: [],
    mode: AudioTranscriptionConfigMode.SMART,
  },
} satisfies LiveConnectConfig;
